import React from 'react'
import { Container, Grid, Menu } from 'semantic-ui-react'
import { NavLink, Route, Switch } from 'react-router-dom'

import UserCard from './userCard'
import DetailView from './detailView'
import Welcome from './welcome'
import { getSelectedList } from '../utility'
import '../css/App.css'

class DesktopView extends React.Component {
  render () {
    return (
      <Container className='main-container'>
        <Grid>
          <Grid.Column width={5}>
            <div className='scrollable-menu'>
              <Menu fluid vertical>
                {getSelectedList().map((x, index) => {
                  return (
                    <Menu.Item as={NavLink} to={`/${index + 1}`} key={index}>
                      <UserCard
                        name={x['Name of the applicant']}
                        display={x['Display picture']}
                        year={x['Year']}
                      />
                    </Menu.Item>
                  )
                })}
              </Menu>
            </div>
          </Grid.Column>
          <Grid.Column stretched width={11}>
            <Switch>
              <Route exact path='/:username' component={DetailView} />
              <Route component={Welcome} />
            </Switch>
          </Grid.Column>
        </Grid>
      </Container>
    )
  }
}

export default DesktopView
